import moment from 'moment';
import 'moment-timezone';
import app from 'srcJs/App';

var setMomentLocale = function setMomentLocale() {
  moment.updateLocale('custom', {
    months: app.t('web_common_js_moment', 'January_February_March_April_May_June_July_August_September_October_November_December').split('_'),
    monthsShort: app.t('web_common_js_moment', 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec').split('_'),
    weekdays: app.t('web_common_js_moment', 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday').split('_'),
    weekdaysShort: app.t('web_common_js_moment', 'Sun_Mon_Tue_Wed_Thu_Fri_Sat').split('_'),
    weekdaysMin: app.t('web_common_js_moment', 'Su_Mo_Tu_We_Th_Fr_Sa').split('_'),
    week: {
      dow: 1
    }
  });
};

var setMomentTimezone = function setMomentTimezone(timezone, timezoneAlias, timezoneServer) {
  if (timezone && moment.tz.zone(timezone)) {
    moment.tz.setDefault(timezone);
  } else if (timezoneAlias && moment.tz.zone(timezoneAlias)) {
    moment.tz.setDefault(timezoneAlias);
  } else if (timezoneServer) {
    moment.tz.setDefault(timezoneServer);
  }
};

export { setMomentLocale, setMomentTimezone };